import { AmI } from "@/contexts/roleContext";
import Footer from "@/features/footer/Footer";
import Header from "@/features/header/Header";
import DisplayProducts from "@/features/startpage/productBox/DisplayProducts";
import Title from "@/features/startpage/Title";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/legacy")({
    component: LegacyRouteComponent,
});

function LegacyRouteComponent() {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col min-h-fit h-screen overflow-hidden" id="main-area">
            <Header />
            <div className="min-h-fit flex h-full w-full pt-12 overflow-auto">
                <div className="h-full flex">
                    <div className="px-4 py-4 lg:pl-64 flex flex-col my-auto space-y-8">
                        <AmI atLeast="compendiaAdmin">
                            <Title title={t("title.dashboard")} link="./admin/" />
                        </AmI>
                        <Title title={t("title.myproducts")} />
                        <DisplayProducts />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
